<div id="password-reset">
  <div id="cover"></div>
  <div class="container-fluid">
    <div data-view="success" class="row" [ngClass]="{'hide': forgotSuccess}">
      <div class="col-md-6">
        <div class="right-side"><img src="/assets/images/WellBrain.png" alt="WellBrain logo" class="header-logo">
          <p class="title">Recover your password</p>
          <p class="description desktop-show">Did you forgot your password ?<br>No worries. We’re here to help. Just enter your email OR
            username and we’ll send you a temporary password.
          </p>
          <p class="description mobile-show">Did you forget your password ?<br>No worries. We’re here to help. Just enter your username OR
            email and we’ll send you a temporary password.
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="left-side">
          <div class="form-container" [ngClass]="{'error': resetError}">
            <div class="error-block"><i class="fa fa-exclamation-triangle"></i><span class="text">No such Username / Email in our database</span></div>
            <form novalidate [formGroup]="reset"   autocomplete="off">
              <fieldset>
                <div class="form-group">
                  <label>Username / Email</label>
                  <input type="text" name="identifier" placeholder="Write here" autocapitalize="off" autocomplete="off" class="col-xs-12 form-control" formControlName="identifier" [(ngModel)]="model.identifier">
                </div>
              </fieldset>
              <button type="submit" class="btn btn-primary btn-block btn-md recover-btn" [disabled]="!reset.valid" (click)="resetPassword()" >Recover My Password</button>
            </form>
          </div><a href="/#/login" class="to-login"><i class="fa fa-chevron-left"></i>Back go Log In</a>
        </div>
      </div>
    </div>
    <div id="reset-success" class="col-md-12" [ngClass]="{'hide': !forgotSuccess}"><img src="/assets/images/WellBrain.png" alt="WellBrain logo">
      <p class="title">Your password has been recovered</p>
      <p class="sent-to">We’ve just sent a temporary password to<br><span class="email">{{forgotEmail}}</span></p>
      <p class="support">If you don’t have an email from us in the next 15 minutes, please write us at<span class="email">&nbsp;support@wellbrain.io</span></p>
      <p>And don’t forget to check your spam folder :)</p><a href="/#/login" class="btn btn-primary btn-block back-to-login"></a>
    </div>
  </div></div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/passwordreset/passwordreset.component.html